import { render, staticRenderFns } from "./withdrawresult.vue?vue&type=template&id=cfd27740&scoped=true"
import script from "./withdrawresult.vue?vue&type=script&lang=js"
export * from "./withdrawresult.vue?vue&type=script&lang=js"
import style0 from "./withdrawresult.vue?vue&type=style&index=0&id=cfd27740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfd27740",
  null
  
)

export default component.exports